export default [
    {
        path: 'classificacao-risco',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-classificacao-risco' */
            '@/views/pronto-atendimento/classificacao-risco/Index'
        ),
        redirect: 'classificacao-risco/index',
        children: [
            {
                name: 'pronto-atendimento-classificacao-risco-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-classificacao-risco' */
                    '@/views/pronto-atendimento/classificacao-risco/List'
                ),
            },
            {
                name: 'pronto-atendimento-classificacao-risco-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-classificacao-risco' */
                    '@/views/pronto-atendimento/classificacao-risco/Form'
                ),
            },
            {
                name: 'pronto-atendimento-classificacao-risco-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-classificacao-risco' */
                    '@/views/pronto-atendimento/classificacao-risco/Form'
                ),
            },
        ],
    },
]